<template>
  <div class="service-about">
    <service-header :signedIn="signedInUser !== null"/>
    <section class="hero">
      <div class="copy-wrapper">
        <h2>
          いつもの<span class="text-service">コミュニケーション</span>をいつでも
        </h2>
        <img :src="require('@/assets/images/logo.png')" alt="Sharewindロゴ"/>
      </div>
      <img :src="require('@/assets/images/service/about_top.png')" alt="アプリケーションイメージ"/>
    </section>
    <section class="features">
      <div class="features-description">
        <div>
          Sharewindのコンセプトは
          <div class="text-service">
            「いつものコミュニケーションをいつでも」
          </div>
        </div>
        <div>リモートワークが普及する中、今までと変わらないコニュニケーションを行えるように</div>
        <div>必要な機能だけを実装して簡単に使えるサービスを目指しています</div>
        <div>どんな職種もどんな仲間もどんな年代も</div>
        <div>Sharewindで簡単に繋がりましょう</div>
      </div>
      <div class="features-inner">
        <div class="description-wrapper">
          <h3>
            <div>オンラインでも</div>
            <div>そこにいる繋がりを</div>
          </h3>
          <div>みんなの状況が一目でわかる、チャットやファイル共有はもちろん、顔が見たいときはWEB会議も気軽に誘える。</div>
          <div>Sharewindは、システマチックなやり取りではなく、もっと人を側に感じられるコミュニケーションを目指しています。</div>
        </div>
        <div class="img-wrapper">
          <img :src="require('@/assets/images/service/about_communication.png')" alt="コミュニケーション機能"/>
        </div>
      </div>
      <div class="features-inner">
        <div class="img-wrapper">
          <img :src="require('@/assets/images/service/about_chat_and_meeting.png')" alt="会議機能"/>
        </div>
        <div class="description-wrapper">
          <h3>
            <div>チャットとWEB会議</div>
            <div>必要なものをシームレスに</div>
          </h3>
          <div>
            LINEで予定を聞いて、zoomでミーティングを作成して、会議のURLをメールで送信する。Sharewindなら全ての作業を簡単に行えます。チャットもWEB会議もボタンひとつで切り替え可能。ちょっと話したい、そんな時は仲間の状況を確認してチャットで声をかけてみましょう。「カフェ」に集まれば、そのままWEB会議が始められます。
          </div>
        </div>
      </div>
    </section>
    <section class="howto">
      <div class="howto-inner">
        <h5>
          例えばこういう使い方
        </h5>
        <div class="howto-inner-list">
          <div class="howto-inner-list-item">
            <h4>
              <div>リモートワークの</div>
              <div>コミュニケーション</div>
            </h4>
            <div>
              Sharewindの特徴は「気軽に」コミュニケーションができる点です。社内にいれば聞いてみるけれど、わざわざ電話するのは気が引ける…。ちょっとした相談をしたいけれど、Web会議を設定して召集するほどでもない…。リモートワークならではの悩みをお持ちの⽅にも、Sharewindでならオフィスにいるような感覚で「気軽に」お使いいただけます。
            </div>
          </div>
          <div class="howto-inner-list-item">
            <h4>
              <div>企業を跨いだ</div>
              <div>プロジェクト</div>
            </h4>
            <div>
              企業を横断したプロジェクトでは、メールで受け取った情報を各メンバーが管理するケースが多くなりがちですが、受信トレイは社内の定期連絡で溢れている…なんていう経験はありませんか？ Sharewindを導⼊すれば、⼤切な情報を⾒落とす⼼配はありません。もっとタイムリーに、最新の情報を把握して、効率よくあなたのプロジェクトを成功に導いてください。
            </div>
          </div>
          <div class="howto-inner-list-item">
            <h4>
              <div>仕事だけじゃなく</div>
              <div>離れた家族や仲間とも</div>
            </h4>
            <div>
              遠⽅に住んでいる家族とはなかなか会うことが難しい。それでもやっぱり⼤事な家族のことは気がかりなもの。家族でトークルームを作成すれば、チャットでの⽂字のやり取りや写真を共有したり、いつでもお互いの近況を報告し合えます。週末には、オンライン帰省して家族とビデオ会話で遠隔ホームパーティなどもいいですね。
            </div>
          </div>
        </div>
      </div>
    </section>
    <service-footer
      :signedIn="signedInUser !== null"
      :route="$route.name"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import ServiceHeader from '@/components/molecules/service/ServiceHeader.vue'
import ServiceFooter from '@/components/molecules/service/ServiceFooter.vue'

export default {
  name: 'ServiceAbout',
  components: {
    ServiceHeader,
    ServiceFooter
  },
  computed: {
    ...mapGetters({
      signedInUser: 'auth/signedInUser'
    })
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/mediaquery";

.service-about {

  .hero,
  .features,
  .howto {
    background-color: white;
  }

  .hero {
    padding: 80px 0 50px 0;

    @include mq(md) {
      padding: 130px 0 50px 0;
    }

    img {
      display: block;
      width: 100%;
      margin: 0 auto;
    }

    .copy-wrapper {
      margin-bottom: 50px;
      padding: 0 20px 0 20px;

      h2 {
        text-align: center;
        font-size: 26px;
        font-weight: bold;
        margin-bottom: 20px;

        @include mq(md) {
          font-size: 32px;
        }
      }

      img {
        width: 240px;
      }
    }
  }

  .features {
    padding: 0 20px 100px 20px;

    &-description {
      font-size: 16px;
      line-height: 1.75;
      margin-bottom: 150px;
      text-align: center;
      font-weight: 600;
    }

    &-inner {
      display: flex;
      flex-direction: column;
      align-items: center;
      max-width: 1100px;
      margin: 0 auto 130px auto;

      &:nth-child(even) {
        flex-direction: column-reverse;
      }

      @include mq(md) {
        flex-direction: row;
        align-items: flex-start;
        justify-content: space-between;

        &:nth-child(even) {
          flex-direction: row;
        }
      }

      .description-wrapper {
        width: 100%;
        font-size: 15px;
        line-height: 1.6;

        @include mq(md) {
          width: 48%;
        }

        h3 {
          text-align: center;
          font-size: 24px;
          line-height: 1.375;
          font-weight: 600;
          margin-bottom: 40px;

          @include mq(md) {
            text-align: left;
            font-size: 32px;
          }
        }
      }

      .img-wrapper {
        width: 100%;
        margin-bottom: 30px;

        @include mq(md) {
          width: 48%;
          margin-bottom: 0;
        }

        img {
          width: 100%;
        }
      }
    }
  }
  .howto {
    margin-bottom: 100px;
    &-inner {
      background-color: $background-color;
      color: $secondary-color;
      padding: 50px 20px;

      h5 {
        text-align: center;
        font-size: 22px;
        font-weight: 600;
        margin-bottom: 50px;
      }

      &-list {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        max-width: 1100px;
        margin: 0 auto;

        &-item {
          font-size: 15px;
          line-height: 1.6;
          background-color: white;
          color: black;
          padding: 30px;
          width: 330px;
          margin-bottom: 20px;

          @include mq(md) {
            margin-bottom: 0;
          }

          &:last-child {
            margin-top: 20px;

            @include mq(lg) {
              margin-top: 0;
            }

          }

          h4 {
            text-align: center;
            font-size: 22px;
            line-height: 1.45;
            font-weight: 600;
            margin-bottom: 30px;

            @include mq(md) {
              text-align: left;
            }
          }
        }
      }
    }
  }
}
</style>
